import { Country, TimeZone, TimeZoneIana } from "utils/market";

export const timeZonesEU = [
  { value: TimeZone.London, label: "London" },
  { value: TimeZone.Stockholm, label: "Stockholm" },
];

export const timeZonesEUIana = [
  { value: TimeZoneIana.London, label: "London" },
  { value: TimeZoneIana.Stockholm, label: "Stockholm" },
];

export const timeZonesUS = [
  { value: TimeZone.Pacific, label: "Pacific Time" },
  { value: TimeZone.Mountain, label: "Mountain Time" },
  { value: TimeZone.Central, label: "Central Time" },
  { value: TimeZone.Eastern, label: "Eastern Time" },
];

export const timeZonesUSIana = [
  { value: TimeZoneIana.Pacific, label: "Pacific Time" },
  { value: TimeZoneIana.Mountain, label: "Mountain Time" },
  { value: TimeZoneIana.Central, label: "Central Time" },
  { value: TimeZoneIana.Eastern, label: "Eastern Time" },
];

export const countriesEU = [
  { value: Country.UK, label: "United Kingdom" },
  { value: Country.SE, label: "Sweden" },
];

export const timeZoneIanaByCountry: Partial<Record<string, TimeZoneIana>> = {
  [Country.UK]: TimeZoneIana.London,
  [Country.SE]: TimeZoneIana.Stockholm,
};
